import {useContext, useMemo} from 'react';

import {CustomizeJourneyContext} from '@amblique/king-living/app/context/customize-journey-context';
import {getSelectedVariantProduct} from '@amblique/king-living/app/utils/customize-selections';

/**
 * Selected cover variant from `c_allVariantsData` for the current journey commit.
 * @param {Object|null|undefined} product - Master PDP product
 */
export function useCommittedCoverVariantProduct(product) {
  const ctx = useContext(CustomizeJourneyContext);
  const coverId = ctx?.committedSelection?.selections?.cover?.productId ??
    ctx?.committedSelection?.selections?.cover?.variantId;

  return useMemo(() => getSelectedVariantProduct(product, coverId), [product, coverId]);
}
